<div class="sabis-tree-combobox">
  <div class="sc-control">
    <div>
      <label *ngIf="scLabel" class="control-label">
        {{ scLabel }}
        <span class="sc-required sabis-tree-combobox__required-star"></span>
      </label>
    </div>

    <input #autoCompleteInput
          type="text"
          placeholder="{{ 'SabisComponents.TreeCombobox.SelectOptionMessage' | translate }}"
          class="sabis-text"
          matInput
          [value]="selectionSummary"
          [disabled]="isDisabled"
          [matAutocomplete]="auto"
          readonly
        (click)="openPanel($event)" />

    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      <mat-option>
        <div class="sabis-tree-combobox__search-container">
          <input #searchInput
                name="tree-combobox-search-input"
                class="sabis-tree-combobox__search-container__search-input"
                autocomplete="off"
                [(ngModel)]="filterText"
                (ngModelChange)="onFilterChanged($event)"
                (click)="$event.stopPropagation()"
                placeholder="{{'SabisComponents.ComboboxSearchPlaceHolderLabel' | translate}}" />
          <button *ngIf="filterText"
                  mat-icon-button
                  aria-label="Clear"
                  (click)="clearSearch($event)"
                  class="sabis-tree-combobox__search-container__clear-button">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </mat-option>
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- leaf node -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
          <button mat-icon-button disabled></button>
          <mat-checkbox class="checklist-leaf-node"
                        (change)="checkboxClick(node, true, false)"
                        [checked]="node.isChecked">
            <span [innerHtml]="node.displayName"></span>
          </mat-checkbox>
        </mat-tree-node>

        <!-- node with children -->
        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
          <button mat-icon-button
                  matTreeNodeToggle
                  [attr.aria-label]="'toggle ' + node.filename">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>

          <mat-checkbox [checked]="node.isChecked"
                        [indeterminate]="node.isPartiallyChecked"
                        (change)="checkboxClick(node, false, false)" *ngIf="scMultiple">
            <span [innerHtml]="node.displayName"></span>
          </mat-checkbox>
          <span [innerHtml]="node.displayName" *ngIf="!scMultiple"></span>
        </mat-tree-node>
      </mat-tree>
    </mat-autocomplete>
  </div>
  <p class="sc-error-message" *ngIf="!scHideValidationMessage && !isValid">{{ validationMessage }}</p>
</div>
